import type { ReactNode, ComponentProps } from 'react';
import { forwardRef } from 'react';
import { Box, Card, CardContent, CardHeader, ResponsiveCarousel } from '@packages/shared';

export type RecoCarouselProps = {
  /** Recommendation items */
  children: ReactNode;
  /** Displayed title above the items */
  title: string;
} & ComponentProps<typeof ResponsiveCarousel>;

/**
 * Base component for Product / Category / Brand sliders
 * */
export const RecoCarousel = forwardRef<HTMLDivElement, RecoCarouselProps>(
  ({ children, title, ...rest }, ref) => (
    // transform: 'scale(1)' overrides the viewport for display: 'fixed' property of underlying ArrowButton component
    <Box sx={{ transform: 'scale(1)' }}>
      <Card ref={ref}>
        <CardHeader
          title={title}
          sx={{
            borderBottom: 1,
            borderColor: 'grey.main',
            py: 1,
            px: 2,
          }}
        />
        <CardContent sx={{ p: 2, '.MuiBox-root[data-index]': { overflow: 'visible' } }}>
          <ResponsiveCarousel
            {...rest}
            showDots={false}
            mobile={{ visibleSlides: 2.5, slidesToScroll: 2, gap: 1.5, showArrows: false }}
            tablet={{ visibleSlides: 3.5, slidesToScroll: 3, gap: 1.5, showArrows: false }}
            desktop={{
              visibleSlides: 5.5,
              slidesToScroll: 5,
              gap: 1.5,
              showArrows: Array.isArray(children) ? children.length > 5 : false,
            }}
          >
            {children}
          </ResponsiveCarousel>
        </CardContent>
      </Card>
    </Box>
  ),
);
